import { PriceMode } from '@common/enums';
import { MaterialModel, RetailerSettings } from '@common/models';

export const getMaterialPriceIndication = (retailerSettings: RetailerSettings): PriceMode => {
    if (retailerSettings.materialPriceIndication?.minMaxPrice) {
        return PriceMode.MINMAX;
    }

    if (retailerSettings.materialPriceIndication?.averagePrice) {
        return PriceMode.AVG;
    }

    return PriceMode.NONE;
};

interface findMaterialByAttributesParams {
    materials: MaterialModel[];
    description?: string | null;
}

export const findMaterialByAttributes = ({
    materials,
    description,
}: findMaterialByAttributesParams): MaterialModel | undefined => {
    if (!materials.length || !description) {
        return;
    }

    return materials.find((material) => material.description === description);
};
